module.exports = __webpack_public_path__ + "assets/img/station19.950bc73f.png";